import { RELATION, RootWidgetTypes, WidgetId } from "@/constants";
import type Widget from "@/model/widget";
import React from "react";
import QuickProviderWidget from "./quick-provider-widget";
import NearestProviderWidget from "./nearest-provider-widget";
import RecentVisitWidget from "./recent-visit-widget";
import BenefitDetailWidget from "./benefit-detail-widget";
import IdCardWidget from "./id-card-widget";
import SpendSummaryWidget from "./spend-summary-widget";
import CampaignWidget from "./campaign-widget";
import PcpWidget from "./pcp-widget";
import ServicesWidget from "./services-widget";
import WidgetOptionsPT from "./widget-option-pt";
import ChatbotWidget from "./chatbot-widget";
import BalanceBillWidget from "./balance-bill-widget";
import TaxFormWidget from "./tax-form-widget";
import FeedbackWidget from "@/pages/components/widget/feedback-widget";
import useUserInfo from "@/hooks/use-user-info";
import { InviteUserWidget } from "./invite-user-widget";
import VideoWidget from "./video-widget";
import { lowerCaseComparison } from "@/lib/string-util";

type WidgetLoaderProps = {
  widget: Widget;
};

const WidgetLoader: React.FC<WidgetLoaderProps> = (props) => {
  const { widget } = props;
  const { relationship, state } = useUserInfo();

  switch (widget.rootWidgetId) {
    case RootWidgetTypes.ProviderSearchByGroup:
      if (widget.widgetId === WidgetId.QuickProvider) {
        return <QuickProviderWidget widget={widget} />;
      } else {
        return <NearestProviderWidget widget={widget} />;
      }
    case RootWidgetTypes.MedClaims:
      return <RecentVisitWidget widget={widget} />;
    case RootWidgetTypes.RxClaims:
      return <RecentVisitWidget widget={widget} />;
    case RootWidgetTypes.Benefits:
      return <BenefitDetailWidget widget={widget} />;
    case RootWidgetTypes.Document:
      if (widget.widgetId === WidgetId.InsuranceCard) {
        return <IdCardWidget widget={widget} />;
      } else {
        return null;
      }
    case RootWidgetTypes.Accumulator:
      return <SpendSummaryWidget widget={widget} />;
    case RootWidgetTypes.Campaign:
      if (
        widget.widgetId === WidgetId.GroupNotification ||
        widget.widgetId === WidgetId.SingleNotification
      ) {
        return <CampaignWidget widget={widget} />;
      } else {
        return null;
      }
    case RootWidgetTypes.PCP:
      return <PcpWidget widget={widget} />;
    case RootWidgetTypes.Services:
      return <ServicesWidget widget={widget} />;
    case RootWidgetTypes.WidgetOptionsPT:
      return <WidgetOptionsPT widget={widget} />;
    case RootWidgetTypes.Chatbot:
      return <ChatbotWidget widget={widget} />;
    case RootWidgetTypes.BalancedBill:
      return <BalanceBillWidget widget={widget} />;
    case RootWidgetTypes.FeedBack:
      return <FeedbackWidget widget={widget} />;
    case RootWidgetTypes.TaxForm: {
      const isEligibleRelationship =
        lowerCaseComparison(relationship, RELATION?.EMPLOYEE) ||
        lowerCaseComparison(relationship, RELATION?.SUBSCRIBER);
      const isMassachusettsMember = state === "MA";

      if (!isEligibleRelationship || !isMassachusettsMember) return null;
      return <TaxFormWidget widget={widget} />;
    }
    case RootWidgetTypes.Share:
      return <InviteUserWidget widget={widget} />;
    case RootWidgetTypes.Video:
      return <VideoWidget widget={widget} />;
    default:
      return null;
  }
};

export default WidgetLoader;
